class NewsletterPopup extends ModalDialog {
  constructor() {
    super();
    this.delay = this.dataset.delay * 1000;
    this.closed = getCookie('newsletter-closed');
    this.subscribed = getCookie('newsletter-subscribed');
    this.form = this.querySelector('.js-form');
    this.ageVerificationPopup = document.querySelector(
      'age-verification-popup'
    );

    if (!!this.form) {
      this.form.addEventListener(
        'submit',
        this.onSubscribe.bind(this)
      );
    }
  }

  connectedCallback() {
    if (Shopify.designMode) {
      if (this.dataset.openInDesignMode === 'true') {
        this.show();
      }
      return;
    }

    if (this.ageVerificationPopup) {
      let prevClassState = this.classList.contains(
        'newsletter-popup-is-hidden'
      );

      var newsletterPopup = this;

      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (mutation.attributeName == 'class') {
            var currentClassState =
              mutation.target.classList.contains(
                'newsletter-popup-is-hidden'
              );
            if (prevClassState !== currentClassState) {
              prevClassState = currentClassState;
              if (!currentClassState) {
                setTimeout(() => {
                  if (
                    newsletterPopup.closed !== null ||
                    newsletterPopup.subscribed !== null
                  )
                    return;
                  newsletterPopup.show();
                }, newsletterPopup.delay);
              }
            }
          }
        });
      });
      observer.observe(this, { attributes: true });
    } else {
      setTimeout(() => {
        if (this.closed !== null || this.subscribed !== null) return;
        this.show();
      }, this.delay);
    }

    // Añadir event listener para el botón de cerrar
    this.addEventListener('click', (e) => {
      if (e.target.classList.contains('newsletter-close-btn')) {
        this.hide();
      }
    });
  }

  hide() {
    super.hide();
    setCookie('newsletter-closed', 'true');
  }

  onSubscribe(event) {
    event.preventDefault(); // ⛔ Evita envío real (puedes agregar integración si deseas)

    // ✅ Guarda cookie de suscripción
    setCookie('newsletter-subscribed', 'true');

    // ✅ Reemplaza contenido por código de descuento
    const content = this.querySelector('.newsletter-popup__content');
    if (content) {
      content.innerHTML = `
        <div class="newsletter-popup__success">
          <button class="newsletter-close-btn" type="button" aria-label="Cerrar popup">×</button>
          <h2>¡Gracias por suscribirte!</h2>
          <p>Tu código de descuento es:</p>
          <div class="discount-code"><strong>Blau15</strong></div>
          <p style="margin-top: 1.5rem;">¡Cópialo y pégalo en el checkout para obtener <strong>15% OFF!</strong></p>
           <p style="font-size: 1rem;">(Válido sólo en la primera compra)</p>
        </div>
      `;
    }
  }
}

customElements.define('newsletter-popup', NewsletterPopup);

// Añade este CSS para el bordeado del código de descuento y el botón de cerrar
const style = document.createElement('style');
style.textContent = `
  .discount-code {
    display: inline-block;
    background-color: #f8f9fa;
    border: 2px dashed #4b6cb7;
    border-radius: 10px;
    padding: 15px 30px;
    font-size: 28px;
    font-weight: bold;
    color: #182848;
    letter-spacing: 2px;
    margin: 15px 0;
    position: relative;
  }
  
  .discount-code::before, .discount-code::after {
    content: "✂️";
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    font-size: 18px;
  }
  
  .discount-code::before {
    left: -15px;
  }
  
  .discount-code::after {
    right: -15px;
  }

  .newsletter-close-btn {
    position: absolute;
    top: 15px;
    right: 15px;
    background: none;
    border: none;
    font-size: 28px;
    font-weight: bold;
    color: #ff0000;
    cursor: pointer;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    transition: all 0.3s ease;
  }

  .newsletter-close-btn:hover {
    background-color: #ffebee;
    color: #cc0000;
  }

  .newsletter-popup__success {
    position: relative;
  }
`;
document.head.appendChild(style);